export default import.meta.ROLLUP_FILE_URL_$ETJ2G0dBnzQUQBKxVjxFg